<template>
  <div class="card card-height">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th class="date-th">Date</th>
          <th>Invoice Number</th>
          <th>Client Name</th>
          <th class="text-right">Invoice Amount</th>
          <th class="text-right">VAT Amount</th>
          <th class="text-right">Total Amount</th>
          <th class="text-right">Bill Sett. Discount</th>
          <th class="text-right">Adjusted Amount</th>
          <th class="text-right">Net Collection</th>
          <th class="text-right">Due Amount</th>
          <th class="text-center">Payment Status</th>
          <th class="text-center action-th">Action</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td>{{ item.date }} </td>
          <td>
            <a href="javascript:void(0)" @click.stop="saleInvoicePrint(item.id)">{{ item.bill_number }}</a>
          </td>
          <td>{{ item.contact_name }}</td>
          <td class="text-right">{{ item.subtotal_amount }}</td>
          <td class="text-right">{{ item.vat_amount }}</td>
          <td class="text-right">{{ item.total_amount }}</td>
          <td class="text-right">{{ item.discount }}</td>
          <td class="text-right">{{ item.adjusted_amount - item.discount }}</td>
          <td class="text-right">{{ item.paid_amount }}</td>
          <td class="text-right">{{ getTotalDue(item) }}</td>
          <td class="text-center">{{ item.payment_status }}</td>
          <td class="text-center">
            <div class="d-flex justify-content-center gap-1">
              <button @click="onClickAddNewButton(item)" v-if="item.payment_status === 'DUE'" class="btn btn-outline-primary btn-sm btn-icon" title="Money Receipt">
                <i class="fas fa-plus"></i>
              </button>
              <div class="dropdown" v-if="item.ipd_receipt_masters && item.ipd_receipt_masters.length">
                <button class="btn btn-outline-primary btn-sm btn-icon dropdown-toggle hide-arrow" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="fas fa-ellipsis-v"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li>
                    <a class="dropdown-item" href="javascript:void(0)" @click="goToPrintMoneyReceipt(item)">
                      <i class="fas fa-print me-50"></i>
                      <span>Print Receipt</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </td>
        </tr>
        <tr v-if="currentPage === lastPage">
          <td colspan="3"></td>
          <td class="text-right"> {{ totalValue && totalValue.total_subtotal_amount }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_vat_amount }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_sum_amount }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_discount_amount }}</td>
          <td class="text-right"> {{ totalValue && getTotalAdjustedAmount(tableItems) }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_paid_amount }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_due_amount }}</td>
          <td> </td>
          <td> </td>
        </tr>
        </tbody>
      </table>
      <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
    <MoneyReceiptPrint
        v-if="store.state.isModalOpenTwo"
        :moneyReceiptData="moneyReceiptData"
        :companyInfo="companyInfo"
    />
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import {ref, onMounted} from "vue";
import {useStore} from "vuex";
import MoneyReceiptPrint from '@/components/molecule/company/dental-os/money-receipt/MoneyReceiptPrint.vue';
import handleCompany from "@/services/modules/company";
import handlePurchase from "@/services/modules/purchase";
import hospitalPdfPrinterHelper from "@/services/utils/pdf/dental/hospitalPdfPrinterHelper";

const props = defineProps({
  tableItems: {
    type: Array,
  },
  currentPage: Number,
  lastPage: Number,
  totalValue: Object,
})
const route = useRoute()
const router = useRouter()
const store = useStore()
const {fetchCompanyInfo} = handleCompany();
const { fetchDentalSalesBill } = handlePurchase();
const {generatePdf:saleInvoicePdf} = hospitalPdfPrinterHelper();

const companyInfo = ref({});
const moneyReceiptData = ref([]);
const invoiceRes = ref(null);

onMounted(() => {
  fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo.value = res.data;
  }).catch((error) => {
    // Error handled
  });
});

const saleInvoicePrint = async (id) => {
  const companyQuery = `?company_id=${route.params.companyId}`;

  try {
    const res = await fetchDentalSalesBill(id, companyQuery);
    if (res) {
      invoiceRes.value = res.data;
      saleInvoicePdf(companyInfo.value, invoiceRes.value, 'BILL', true, true, invoiceRes.value.sale_type === 'opd_bill');
    }
  } catch (err) {
    // Error handled
  }
}

const onClickAddNewButton = (item) =>  {
  let query = {
   saleMasterId:item.id,
   contactId:item.contact_profile_id,
   type:'pending-money-receipt',
   start:route.query.start,
   end:route.query.end,
   page:route.query.page,
   ipd_register_id: item.ipd_register_id,
  }
  return router.push({name: 'dental-sales-invoice-pay', params: route.params, query: query})
}

const getTotalDue = (item) => {
  return parseFloat(item.total_amount) - (parseFloat(item.paid_amount) + parseFloat(item.adjusted_amount))
}

const getTotalAdjustedAmount = (items) => {
  return items.reduce((total, saleMaster) => total + (saleMaster.adjusted_amount - saleMaster.discount), 0);
}

const goToPrintMoneyReceipt = (item) => {
  moneyReceiptData.value = item.ipd_receipt_masters && item.ipd_receipt_masters.length ? item.ipd_receipt_masters : [];
  store.state.isModalOpenTwo = true;
}

</script>

<style scoped>
.card-height {
  min-height: calc(100vh - 180px);
}
.table-responsive {
  overflow-x: hidden; /* Prevent horizontal scroll */
}
.mr-5 {
  margin-right: 5px;
}
.action-th {
  width: 8%;
  text-align: center;
}
.date-th {
  width: 8%;
}

</style>